// 9fbef606107a605d69c0edbcd8029e5d
import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import {
  ListContainer,
  ImageTag,
  ItemDetails,
  ProductName,
  ProductPrice,
  SalesPrice,
  PriceSection,
  ShopNowButton,
  ButtonText,
  ScrollContainer,
} from '../styles/ProductList.style';
import { trackProductListImpression } from '../../../utils/ShopByLookStylitics.util';

const ProductList = ({
  onClose,
  brandName,
  productList,
  isMobileView,
  isFullRowView,
  shopButtonText,
  aspectRatioObj,
  onQuickViewOpenClick,
  showList,
  modalVisible,
  adobeAnalyticsProps,
}) => {
  const handlePress = (index) => {
    if (isMobileView) {
      onClose();
    }
    const { remoteId } = productList[index];
    if (remoteId) {
      onQuickViewOpenClick({
        colorProductId: remoteId,
        generalProductId: remoteId,
        fromPage: 'plp',
        brand: brandName,
      });
    }
  };

  useEffect(() => {
    if (showList || modalVisible) {
      trackProductListImpression(productList, adobeAnalyticsProps);
    }
  }, [showList, modalVisible]);

  return (
    <ScrollContainer
      className="product-list-container"
      aspectRatioObj={aspectRatioObj}
      isFullRowView={isFullRowView}
    >
      {productList.map((item, index) => (
        <ListContainer
          key={item.remoteId}
          isLastItem={index === productList.length - 1}
          onClick={() => handlePress(index)}
        >
          <ImageTag src={item.smallImageUrl} alt={item.name} />
          <ItemDetails>
            <ProductName>{item.name}</ProductName>
            <PriceSection>
              {item.productPrice && <ProductPrice>${item.productPrice}</ProductPrice>}
              {item.discountedPrice && <SalesPrice>${item.discountedPrice}</SalesPrice>}
            </PriceSection>
            <ShopNowButton>
              <ButtonText>{shopButtonText}</ButtonText>
            </ShopNowButton>
          </ItemDetails>
        </ListContainer>
      ))}
    </ScrollContainer>
  );
};

ProductList.propTypes = {
  onClose: PropTypes.func,
  brandName: PropTypes.string,
  isFullRowView: PropTypes.bool,
  aspectRatioObj: PropTypes.shape({}),
  isMobileView: PropTypes.bool.isRequired,
  shopButtonText: PropTypes.string.isRequired,
  onQuickViewOpenClick: PropTypes.func.isRequired,
  productList: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string.isRequired,
      smallImageUrl: PropTypes.string,
      productPrice: PropTypes.number,
      discountedPrice: PropTypes.number,
      remoteId: PropTypes.string,
    })
  ).isRequired,
  showList: PropTypes.bool.isRequired,
  adobeAnalyticsProps: PropTypes.shape({}).isRequired,
  modalVisible: PropTypes.bool.isRequired,
};

ProductList.defaultProps = {
  brandName: '',
  onClose: () => {},
  aspectRatioObj: {},
  isFullRowView: false,
};

export default ProductList;
